import { combineReducers } from 'redux';

import pinSearchferMappedReducer from './pin-search/reducer/pinSearchMappedReducer';

export const pinSearchCombineReducer = () => combineReducers({

    pinSearch: pinSearchferMappedReducer,

});
